import React, { Component } from 'react';
import { FieldArray } from 'redux-form';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { SnapcodeContainer } from '../snapcode/SnapcodeContainer';

import Button from 'components/buttons/button';
import { FieldArrayRenderer } from 'components/form/fieldArrayRenderer/fieldArrayRenderer';
import styles from './SnapcodesForm.module.scss';

export class SnapcodesForm extends Component<any> {
  componentDidMount(): void {
    const { snapcodes, addSnapcode } = this.props;

    if (!snapcodes || !snapcodes.length) {
      addSnapcode({
        name: 'Generic',
        default: true,
      });
    }
  }

  componentWillUnmount(): void {
    const { clear } = this.props;

    clear();
  }

  handleAdd = () => {
    const { addSnapcode } = this.props;

    addSnapcode({});
  };

  render() {
    const { removeSnapcode } = this.props;

    return (
      <div className={styles.wrapper}>
        <FieldArray
          name="snapcodes"
          component={FieldArrayRenderer}
          fieldComponent={SnapcodeContainer}
          handleRemove={removeSnapcode}
        />
        <Button
          className={styles.addButton}
          type="button"
          text="Add Individual Snapchat Barcode"
          icon={faPlus}
          onClick={this.handleAdd}
        />
      </div>
    );
  }
}
